function getI18nString( key, fallback ) {
	const el = document.querySelector( `#wdg-poh-i18n [data-i18n="${ key }"]` );
	const text = el ? el.textContent.trim() : '';
	return text || fallback;
}

const i18n = {
	play: getI18nString( 'video_play', 'Play' ),
	pause: getI18nString( 'video_pause', 'Pause' ),
	mute: getI18nString( 'video_mute', 'Mute' ),
	unmute: getI18nString( 'video_unmute', 'Unmute' ),
	fullscreen: getI18nString( 'video_fullscreen', 'Fullscreen' ),
	exitFullscreen: getI18nString( 'video_exit_fullscreen', 'Exit fullscreen' ),
};

document.querySelectorAll( '.wp-block-video video.has-custom-video-ui' ).forEach( ( video ) => {
	const wrapper = video.closest( '.wp-block-video' );

	if ( wrapper.querySelector( '.video-ui' ) ) {
		return;
	}

	video.setAttribute( 'playsinline', 'true' );

	const ui = document.createElement( 'div' );
	ui.className = 'video-ui';

	const playBtn = document.createElement( 'button' );
	playBtn.className = 'video-ui__btn video-ui__play';
	playBtn.setAttribute( 'aria-pressed', 'false' );
	playBtn.setAttribute( 'aria-label', i18n.play );

	const muteBtn = document.createElement( 'button' );
	muteBtn.className = 'video-ui__btn video-ui__mute';
	muteBtn.setAttribute( 'aria-pressed', video.muted ? 'true' : 'false' );
	muteBtn.setAttribute( 'aria-label', i18n.mute );

	const fullscreenBtn = document.createElement( 'button' );
	fullscreenBtn.className = 'video-ui__btn video-ui__fullscreen';
	fullscreenBtn.setAttribute( 'aria-pressed', 'false' );
	fullscreenBtn.setAttribute( 'aria-label', i18n.fullscreen );

	ui.append( playBtn, muteBtn, fullscreenBtn );
	wrapper.append( ui );

	function syncPlayState() {
		const isPlaying = ! video.paused;
		playBtn.classList.toggle( 'is-playing', isPlaying );
		playBtn.classList.toggle( 'is-paused', ! isPlaying );
		playBtn.setAttribute( 'aria-pressed', isPlaying ? 'true' : 'false' );
		playBtn.setAttribute( 'aria-label', isPlaying ? i18n.pause : i18n.play );
	}

	function syncMuteState() {
		const isMuted = !! video.muted;
		muteBtn.classList.toggle( 'is-muted', isMuted );
		muteBtn.classList.toggle( 'is-unmuted', ! isMuted );
		muteBtn.setAttribute( 'aria-pressed', isMuted ? 'true' : 'false' );
		muteBtn.setAttribute( 'aria-label', isMuted ? i18n.unmute : i18n.mute );
	}

	function syncFullscreenState() {
		const isFullscreen = document.fullscreenElement === wrapper || document.webkitFullscreenElement === wrapper;
		fullscreenBtn.classList.toggle( 'is-fullscreen', isFullscreen );
		fullscreenBtn.setAttribute( 'aria-pressed', isFullscreen ? 'true' : 'false' );
		fullscreenBtn.setAttribute( 'aria-label', isFullscreen ? i18n.exitFullscreen : i18n.fullscreen );
	}

	playBtn.addEventListener( 'click', () => {
		if ( video.paused ) {
			video.play();
		} else {
			video.pause();
		}
		syncPlayState();
	} );

	muteBtn.addEventListener( 'click', () => {
		video.muted = ! video.muted;
		syncMuteState();
	} );

	fullscreenBtn.addEventListener( 'click', () => {
		if ( document.fullscreenElement || document.webkitFullscreenElement ) {
			document.exitFullscreen?.() || document.webkitExitFullscreen?.();
		} else {
			wrapper.requestFullscreen?.() || wrapper.webkitRequestFullscreen?.();
		}
	} );

	video.addEventListener( 'play', syncPlayState );
	video.addEventListener( 'pause', syncPlayState );
	video.addEventListener( 'volumechange', syncMuteState );
	video.addEventListener( 'ended', syncPlayState );
	document.addEventListener( 'fullscreenchange', syncFullscreenState );
	document.addEventListener( 'webkitfullscreenchange', syncFullscreenState );

	syncPlayState();
	syncMuteState();
} );
